import { useMemo } from "react";

import { type StockStatusElements } from "@jti/fe-common";
import { type IGetStockStatusesQuery, useStockStatuses } from "@jti/magento";
import type { ApiMagentoProduct } from "@jti/magento-types";
import { useFormContext } from "@jti/ui/components/Form";

import { useConsumablesProductDetailsContext } from "@product-details/providers/ConsumablesProductDetailsProvider";
import { getStockStatusesForBundleItems } from "@product-details/utils/getOptions";
import { getSiblingItemsStockStatus } from "@product-details/utils/getSiblingItemsStockStatus";

import type { ConsumablesFormValues } from "../../ConsumablesForm.types";

export const useConsumablesStockStatuses = () => {
  const { currentMatrixItem, consumablesProductDetailsComponentData } = useConsumablesProductDetailsContext();

  const { items: consumables } = consumablesProductDetailsComponentData.consumablesMatrixData;

  const form = useFormContext<ConsumablesFormValues>();

  const purchaseTypeInputValue = form.watch("purchaseType");
  const currentPackagingFormatId = form.watch("packagingFormatId");
  const currentPackagingFormat = form.watch("packagingFormat");

  const categoriesSKUList = useMemo(() => {
    return consumables
      .filter(
        (item) => item.packagingFormatId === currentPackagingFormatId && item.purchaseType === purchaseTypeInputValue
      )
      .map((item) => item.sku);
  }, [consumables, purchaseTypeInputValue, currentPackagingFormatId, currentMatrixItem]);

  const selectStocksStatuses = (data: IGetStockStatusesQuery): StockStatusElements => {
    if (currentPackagingFormat?.contentsType === "mixed" && data.products.items[0]) {
      return getStockStatusesForBundleItems(data.products.items[0] as ApiMagentoProduct);
    }

    return getSiblingItemsStockStatus(data);
  };

  const result = useStockStatuses({
    categoriesSKUList,
    select: selectStocksStatuses,
  });

  return result;
};
